import { create } from 'zustand';
import type { DashboardConfig } from '@/types/dashboard-config';

/**
 * Lightweight store that remembers the last imported dashboard config
 * so the "Eşleşmeleri kontrol et" sidebar button can re-open the
 * review modal without forcing the user to re-pick the JSON file.
 */
type ImportConfigState = {
  lastConfig: DashboardConfig | null;
  setLastConfig: (config: DashboardConfig | null) => void;
};

export const useImportConfigStore = create<ImportConfigState>((set) => ({
  lastConfig: null,
  setLastConfig: (config) => set({ lastConfig: config }),
}));
